import React from 'react';
import * as PropTypes from 'prop-types';
import { map, isEmpty } from 'lodash';
import styles from './TaxExemptionsList.module.scss';
import DateFormats from 'constants/DateFormats';
import moment from 'moment';
import Warning from 'components/Warning';
import { routeMap } from 'router';
import config from 'config';
import { Link } from 'redux-little-router';
import BlueBlock from 'modules/Profile/components/PersonalData/components/BlueBlock';

export default function TaxExemptionsList({ taxExemptions }) {
  if (isEmpty(taxExemptions)) return null;
  return (
    <div className={styles.TaxExemptionsList}>
      <h2>Льготы</h2>
      {map(taxExemptions, ({ id, name, endDate, startDate }) => (
        <BlueBlock key={id}>
          <p>{name}</p>
          <div className={styles.periodText}>
            {startDate && (
              <p>
                Дата начала:{' '}
                <span>{moment(startDate, DateFormats.long_dash).format(DateFormats.long)}</span>
              </p>
            )}
            {endDate && (
              <p>
                Дата окончания:{' '}
                <span>{moment(endDate, DateFormats.long_dash).format(DateFormats.long)}</span>
              </p>
            )}
          </div>
        </BlueBlock>
      ))}
      {!config.isInspectorArm && (
        <Warning message={<Link href={routeMap.applyExemption}>Нет сведений о моей льготе</Link>} />
      )}
    </div>
  );
}

TaxExemptionsList.propTypes = {
  taxExemptions: PropTypes.array,
};
